module.exports = __webpack_public_path__ + "static/img/img-preparing.3f76207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/img-preparing.png
// module id = 5onf
// module chunks = 134